import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./Pages/Login.jsx";
import Dashboard from "./Pages/Dashboard.jsx";
import Employees from "./Pages/Employees.jsx";
import Trucks from "./Pages/Trucks.jsx";
import NewScheduleForm from './Forms/NewScheduleForm.jsx';
import Schedules from './Pages/Schedules.jsx';
import ProtectedRoute from "./UI/ProtectedRoute.jsx";  // Add the ProtectedRoute for role-based access
import './App.css'

function App() {
  return (
    <Router>
      <Routes>
        {/* Login page */}
        <Route path="/" element={<Login />} />
        
        {/* Protected routes after login */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/employees" element={
          <ProtectedRoute>
            <Employees />
          </ProtectedRoute>
        } />
        
        <Route path="/trucks" element={
          <ProtectedRoute>
            <Trucks />
          </ProtectedRoute>
        } />

        <Route path="/weekly-schedules" element={
          <ProtectedRoute>
            <Schedules />
          </ProtectedRoute>
        } />
        
        <Route path="/new-weekly-schedule" element={
          <ProtectedRoute>
            <NewScheduleForm />
          </ProtectedRoute>
        } />
        
      </Routes>
    </Router>
  );
}

export default App;